import { SkeletonBase } from "./SkeletonBase"

export const SkeletonRollCall = () => {

    return (
        <>
            {[0, 0, 0, 0, 0,].map((item: any, index: number) =>
                <div key={index} className='w-full h-[55px]   shadow rounded-md mt-3  relative overflow-hidden'>
                    <SkeletonBase />
                </div>
            )}
        </>
    )
}